import { FC } from 'react';
import { useFlowsConfigureParams } from '@flows/src/hooks/flows-configure/useFlowsConfigureParams';
import { useFlowInfo } from '@flows/src/api/getFlowInfo';
import FlowsConfigureInsurancesAnva from './FlowsConfigureInsurancesAnva';
import FlowsConfigureInsurancesYellowHive from './FlowsConfigureInsurancesYellowHive';
import LoadingSpinner from '@common/src/components/LoadingSpinner';

const FlowsConfigureInsurances: FC = () => {
  const { flowId } = useFlowsConfigureParams();
  const { data: flowInfo, isLoading } = useFlowInfo(flowId || '');

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (flowInfo?.sub_type === 'YELLOWHIVE') {
    return <FlowsConfigureInsurancesYellowHive />;
  }

  if (flowInfo?.sub_type === 'ANVA') {
    return <FlowsConfigureInsurancesAnva />;
  }

  return null;
};

export default FlowsConfigureInsurances;
